module.exports = __webpack_public_path__ + "img/tips-table-icon.fded169b.svg";